// Core Imports
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from './../../_redux/reducers/AuthSlice';
import { motion } from "framer-motion";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import {
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faLongArrowAltUp,
    faLongArrowAltDown,
    faLongArrowAltLeft,
    faLongArrowAltRight,
} from '@fortawesome/free-solid-svg-icons';


export const Navigation = () => {
    const dispatch = useDispatch();
    const isAuth = useSelector(isAuthenticated);

    return (
        <>
            <div className="component navigation-component">
                <div className="navigation-component-container">
                    <div className="navigation-component-inner-container">

                        <Link className='brand' to="/">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 510.84">
                                <g id="Core_Logo" data-name="Core Logo" transform="translate(-187.999 -1280.319)">
                                    <path data-name="Union 16" className="path path-1" d="M0,509.631V377.711H295.588a85.446,85.446,0,0,0,17.032-1.8,84.45,84.45,0,0,0,30.205-12.838,85.113,85.113,0,0,0,30.585-37.292,84.365,84.365,0,0,0,4.917-15.888,85.678,85.678,0,0,0,0-34.105,84.391,84.391,0,0,0-12.7-30.272,85.145,85.145,0,0,0-37.151-30.755,84.493,84.493,0,0,0-15.859-4.991,85.36,85.36,0,0,0-12.041-1.627l102.983-103.1c4.434,2.564,8.822,5.313,13.043,8.171A217.429,217.429,0,0,1,495,208.551,215.526,215.526,0,0,1,507.6,249.2a218.85,218.85,0,0,1,0,87.279,215.554,215.554,0,0,1-32.554,77.444,217.476,217.476,0,0,1-95.208,78.55,215.6,215.6,0,0,1-40.629,12.679,218.349,218.349,0,0,1-43.626,4.478ZM0,0H219.932L0,219.869Z" transform="translate(187.999 1281.527)" />
                                    <path data-name="Union 13" className="path path-2" d="M0,382.116V323.281L323.139,0H509.048L93.244,416.566l-.135-.135L0,509.747Z" transform="translate(188.173 1280.319)" />
                                </g>
                            </svg>
                        </Link>

                    </div>
                </div>
            </div>
        </>
    );
}

export const Footer = () => {

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <>
            <div className="component footer-component">

                <div className="row footer-component--one">
                    <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <motion.h3
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.75 }}>Interested in working together?</motion.h3>
                    </div>
                </div>

                <div className="row footer-component--two">

                    <div className="col col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                    <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-component--two-one">
                        <div className="contact-info">
                            <h4>zachbania.co</h4>
                            <p>Zrbania@gmail.com</p>
                            <p>(920) 264-3790</p>
                        </div>
                    </div>
                    <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-component--two-two">
                        <ul className="social-links">

                            {/* <li>
                                <Link
                                    to="https://www.instagram.com/zachbania.co/"
                                    className="social-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={faInstagram} />
                                </Link>
                            </li> */}


                            <li>
                                <Link
                                    to="https://github.com/ZachBania?tab=repositories"
                                    className="social-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={faGithub} />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="https://www.linkedin.com/in/zachbania9202643790/"
                                    className="social-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </Link>
                            </li>
                        </ul>

                    </div>
                    <div className="col col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                </div>

                <div className="row footer-component--three">
                    <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <p>zachbania.co</p>
                    </div>
                    <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <Link className="chevron-up" onClick={handleScrollToTop}>
                            <FontAwesomeIcon icon={faChevronUp} />
                        </Link>
                        <p>EST 2022</p>
                    </div>
                </div>




            </div>
        </>
    );
}